import { networkService } from "services/networkService";
import {
  METHOD_HDRS_LIST,
  METHOD_HDRS_CREATE,
  METHOD_HDRS_UPDATE,
  METHOD_HDRS_DELETE,
  METHOD_HDRS_DETAIL,
} from "constants/admin/masters/hdrs";
class HdrsService {
  getAll = (data) => {
    return networkService
      .post(METHOD_HDRS_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_HDRS_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_HDRS_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_HDRS_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_HDRS_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default HdrsService;
